// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"386c1239","121":"6f4dfe5b","163":"0102956d","251":"21917af0","328":"a93153d7","420":"48d92443","460":"abb3d76b","606":"46c69229","693":"3d7fe58e","767":"77d58cfb","795":"2997eff2","848":"67e2e762","916":"399e34e5"}[chunkId] + ".chunk.js";
};